import GetStartedPage from "@/components/get-started/GetStartedPage";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

const GetStarted = ({ type }) => {
    return isProspect(type) ? <GetStartedPage /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default GetStarted;
